// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { urlSettings } from "src/app/http-confing/settings/urlSettings";

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAnzKv-J8xUxO7Pgmi1_nQdEyQIcx_nnrE",
    authDomain: "realestate-crm-56d7f.firebaseapp.com",
    databaseURL: "https://realestate-crm-56d7f.firebaseio.com",
    projectId: "realestate-crm-56d7f",
    storageBucket: "realestate-crm-56d7f.appspot.com",
    messagingSenderId: "15239767275",
    appId: "1:15239767275:web:5174c4772ac7c55eab4aae",
    measurementId: "G-BQGMKPWLY1",
  },
};

urlSettings.Settings = {
  // apiHost: "192.168.1.38",
  // apiEndPoint: "api",
  // apiProtocol: "http",
  // apiPort: 8000,

  apiProtocol: "https",
  apiHost: "backend.leadscrm.net",
  apiEndPoint: "api",
  language: "en",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
